<template>
  <span v-if="houseSpinner" class="relative">
    <UiIcon
      src="/svg/spinner/loading-spinner-house-01.svg"
      alt="loader house"
      :width="props.width"
      :height="props.height"
      class="absolute"
    />
    <UiIcon
      src="/svg/spinner/loading-spinner-house-02.svg"
      alt="loader spinner"
      :width="props.width"
      :height="props.height"
      class="animate-spin"
    />
  </span>
  <UiIcon
    v-if="spinner"
    src="/svg/spinner/loading-spinner-search.svg"
    alt="loader spinner"
    :width="props.width"
    :height="props.height"
    class="inline-block animate-spin -m-2"
  />
</template>

<script lang="ts" setup>
const props = defineProps({
  design: {
    type: String,
    default: 'spinner'
  },
  width: {
    type: [Number, String],
    default: 60
  },
  height: {
    type: [Number, String],
    default: 60
  }
})
const spinner = computed(() => props.design === 'spinner')
const houseSpinner = computed(() => props.design === 'house')
</script>
